// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconDeliveriesPath = 'M21.997 24c0 .551-.449 1-1 1h-12c-.55 0-1-.449-1-1v-4h14v4ZM9.057 11.065c.31-.042.624-.065.94-.065 1.454 0 2.821.458 4 1.287V18h-.456l-4.485-6.935ZM14.996 4a7.974 7.974 0 0 1 7.563 5.373c-2.505-.746-5.366-.322-7.563 1.148a8.973 8.973 0 0 0-7.563-1.148A7.974 7.974 0 0 1 14.997 4Zm1.43 14h-.43v-5.713c1.18-.829 2.546-1.287 4-1.287.186 0 .368.021.552.036L16.427 18Zm6.168-6.496c.293.119.58.254.852.412l1.697.98-.202-1.95A9.966 9.966 0 0 0 14.997 2a9.966 9.966 0 0 0-9.945 8.946l-.202 1.95 1.697-.98c.165-.096.341-.171.513-.252L11.16 18H5.996v6c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-6h-5.246l3.844-6.496Z';
var NavigationIconDeliveries = baseIcon('NavigationIconDeliveries', {
  getPath: () => NavigationIconDeliveriesPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconDeliveries;
//# sourceMappingURL=index.js.map